function styleTeaser(embed) {
    if (!embed.shadowRoot) return;

    const style = document.createElement('style');
    style.textContent = `

          /* ── HIDE SCROLLBAR ── */
      :host {
        overflow: hidden !important;
      }
      * {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      *::-webkit-scrollbar {
        display: none !important;
        width: 0 !important;
        height: 0 !important;
      }

      /* ── TEASER ── */
      ._teaserContainer_trejf_5 {
        padding: 5px 10px !important;
        border-radius: 0 !important;
        background: #FAF7F2 !important;
        border-top: 1px solid rgba(176, 128, 96, 0.35) !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: none !important;
        box-shadow: 0 -4px 24px rgba(176, 128, 96, 0.08) !important;
        gap: 14px !important;
      }
      ._teaserHeading_trejf_28 {
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-style: italic !important;
        font-weight: 600 !important;
        font-size: 13px !important;
        letter-spacing: 0.18em !important;
        color: #1E1614 !important;
        line-height: 1.2 !important;
        margin: 0 !important;
        text-transform: none !important;
      }

      /* ── OVERLAY BACKGROUND ── */
      ._overlayBackground_1q1d2_123 {
        background: rgba(30, 22, 20, 0.55) !important;
        backdrop-filter: blur(3px) !important;
      }

      /* ── FORM CONTAINER ── */
      ._formContainer_1q1d2_30 {
        border-radius: 0 !important;
        background: #FAF7F2 !important;
        box-shadow: 0 32px 80px rgba(30, 22, 20, 0.18) !important;
        border-top: 2px solid rgba(176, 128, 96, 0.4) !important;
      }

      /* ── FORM HEADER ── */
      ._formHeader_cit2d_24 {
        padding-bottom: 20px !important;
        border-bottom: 1px solid rgba(176, 128, 96, 0.2) !important;
        margin-bottom: 24px !important;
      }

      /* ── HEADING ── */
      ._textHeading_2aowh_35 {
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-style: italic !important;
        font-weight: 500 !important;
        font-size: 30px !important;
        letter-spacing: -0.01em !important;
        color: #1E1614 !important;
        line-height: 1.15 !important;
        margin: 0 0 12px !important;
      }

      /* ── BODY TEXT ── */
      ._textBody_2aowh_10 p {
        font-family: 'Jost', sans-serif !important;
        font-weight: 500 !important;
        font-size: 11px !important;
        letter-spacing: 0.28em !important;
        line-height: 1.8 !important;
        margin: 0 !important;
        color: #1E1614 !important;
        opacity: 1 !important;
      }

      /* ── INPUT FIELDS ── */
      ._formInputField_nag3b_7 {
        border-radius: 0 !important;
        border: none !important;
        border-bottom: 1px solid rgba(176, 128, 96, 0.8) !important;
        background: transparent !important;
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        color: #1E1614 !important;
        padding: 35px 0 8px !important;
        box-shadow: none !important;
        transition: border-color 0.2s !important;
      }
      ._formInputField_nag3b_7:focus {
        border-bottom: 1px solid rgba(176, 128, 96, 0.8) !important;
        outline: none !important;
        box-shadow: none !important;
      }

      /* ── INPUT LABELS ── */
      ._formInputFieldLabel_1mxsl_38 {
        font-family: 'Jost', sans-serif !important;
        font-weight: 500 !important;
        font-size: 10px !important;
        letter-spacing: 0.42em !important;
        color: #1E1614 !important;
        text-transform: uppercase !important;
        padding:0px;      }

      /* ── PHONE INPUT ── */
      ._formPhoneInputField_piv1u_17 {
        border-radius: 0 !important;
        border: none !important;
        border-bottom: 1px solid rgba(176, 128, 96, 0.8) !important;
        background: transparent !important;
        font-family: 'Cormorant Garamond', Georgia, serif !important;
        font-weight: 500 !important;
        font-size: 15px !important;
        color: #1E1614 !important;
        box-shadow: none !important;
      }

/* ── PHONE COUNTRY SELECTOR ── */
._selectToggle_12thd_25 {
  border-radius: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

/* ── PHONE ROW WRAPPER — centres flag/selector with input ── */
._formPhoneRow_piv1u_1,
._phoneInputWrapper_piv1u_1 {
  display: flex !important;
  align-items: center !important;
}

/* ── BIRTHDAY LABEL ── */
._birthdayText_rzr7e_15 {
  font-family: 'Jost', sans-serif !important;
  font-weight: 500 !important;
  font-size: 10px !important;
  letter-spacing: 0.42em !important;
  color: #1E1614 !important;
  text-transform: uppercase !important;
  margin-bottom: 0px !important;   /* ← was likely 20–24px, now tight */
  display: block !important;
}

/* ── BIRTHDAY CONTAINER ── */
._birthdayContainer_rzr7e_1 {
  gap: 0 !important;
  margin-top: 0 !important;
  padding-top: 0 !important;
}

      /* ── SUBMIT BUTTON ── */
      ._formSubmitButton_cit2d_96 {
        border-radius: 0 !important;
        background: #1E1614 !important;
        font-family: 'Jost', sans-serif !important;
        font-weight: 500 !important;
        font-size: 10px !important;
        letter-spacing: 0.52em !important;
        color: #FAF7F2 !important;
        text-transform: uppercase !important;
        padding: 16px 24px !important;
        border: 1px solid transparent !important;
        transition: background 0.25s, border-color 0.25s, color 0.25s !important;
        margin-top: 8px !important;
      }
      ._formSubmitButton_cit2d_96:hover {
        background: transparent !important;
        border-color: rgba(176, 128, 96, 0.5) !important;
        color: #1E1614 !important;
      }

/* ── DISCLAIMER ── */
._formDisclaimer_cit2d_38 p {
  font-family: 'Jost', sans-serif !important;
  font-weight: 500 !important;
  font-size: 10px !important;
  letter-spacing: 0.2em !important;
  color: #1E1614 !important;
  opacity: 1 !important;
  line-height: 1.9 !important;
}

      /* ── CLOSE BUTTON ── */
      ._formCloseButton_1684x_4 {
        background: transparent !important;
        border-radius: 0 !important;
        border: 1px solid rgba(176, 128, 96, 0.8) !important;
        width: 20px !important;
        height: 20px !important;
        opacity: 1 !important;
        transition: opacity 0.2s !important;
      }
      ._formCloseButton_1684x_4:hover {
        opacity: 1 !important;
      }
      ._formCloseButton_1684x_4 svg {
        width: 8px !important;
        height: 8px !important;
        fill: #1E1614 !important;
      }
    `;

    embed.shadowRoot.appendChild(style);
  }

  const existing = document.querySelector('shopify-forms-embed');
  if (existing) {
    styleTeaser(existing);
  } else {
    const observer = new MutationObserver((mutations, obs) => {
      const embed = document.querySelector('shopify-forms-embed');
      if (embed) {
        styleTeaser(embed);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  